import AbstractModule from './AbstractModule';
import Scrollbar from 'smooth-scrollbar';
import Resize from '../utils/Resize';
import {$window, $document, $body} from '../utils/environment';

export default class extends AbstractModule {

    constructor(options) {
        super(options);

        this.init();

        this.hasSmoothScroll = false;
    }

    init(){

        const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        if (iOS || window.matchMedia('(max-width: 1279px)').matches) {
            this.$el.addClass('has-scroll');
        } else {
            this.hasSmoothScroll = true;
            this.$el.addClass('has-smooth-scroll');
        }

        //if smoothscrollbar initializable
        if(this.hasSmoothScroll){
            this.scrollbar = Scrollbar.init(this.$el[0]);
            this.setScrollbarLimit();
            $document.on('rebuild.Sticky', () => this.rebuild());

            // Resize event
            var resize = new Resize();
            resize.on('resize:end', () => this.rebuild());
        }




    }

    /**
     * Update elements and recalculate all the positions on the page
     */
    rebuild() {
        if (!window.navigator.userAgent.match(/Trident/)) {
            this.scrollbar.update();
        }
        this.setScrollbarLimit();
        this.scrollbar.scrollTo(0, 0 , 400);
    }

    /**
     * Set the scroll bar limit
     */
    setScrollbarLimit() {
        this.scrollbarLimit = this.scrollbar.limit.y + this.windowHeight;
    }

    destroy() {
        this.$el.off('.Sticky');

    }
}
